import styled from 'styled-components'
// themes
import { colors } from 'themes'

export const Wrapper = styled('div')`
  background-color: ${colors.gray190};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  padding: 8px;

  & > div {
    margin-bottom: 8px;
  }
`

export const Title = styled('div')`
  font-size: 18px;
  margin-top: 24px;
`
